export const ingredientToFormData = (ingredient: Ingredient) => {
    return {
        name: ingredient.name,
        price: ingredient.price.value,
        priceUnit: ingredient.price.unit,
        mass: ingredient.mass.value,
        massUnit: ingredient.mass.unit,
    }
}
export const formDataToIngredient = (formData: any): Ingredient => {
    return {
        name: formData.name,
        price: {
            value: formData.price,
            unit: formData.priceUnit
        },
        mass: {
            value: formData.mass,
            unit: formData.massUnit
        }
    }
}
